import React, { useEffect, useState } from 'react';
import { AgButton } from '../components/ag-ui';
import { registerServiceWorker, applyUpdate } from './registerServiceWorker';
import css from './UpdateBanner.module.css';

interface UpdateBannerProps {
  /** Shell mobile : remonte la bannière au-dessus de la barre d'onglets (56 px). */
  raised?: boolean;
}

/** Bannière « Nouvelle version disponible » — monte l'enregistrement du service worker. */
const UpdateBanner: React.FC<UpdateBannerProps> = ({ raised = false }) => {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);
  useEffect(() => { registerServiceWorker({ onUpdate: setRegistration }); }, []);
  if (!registration) return null;
  return (
    <div className={[css.banner, raised ? css.raised : ''].filter(Boolean).join(' ')} role="status">
      <p>Nouvelle version disponible.</p>
      <AgButton size="sm" onClick={() => applyUpdate(registration)}>Recharger</AgButton>
    </div>
  );
};

export default UpdateBanner;
